/** In this file entities are declared */
import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../../utils";

const ModuleDefinition = {
  name: "Nested Questionnaire",
  entityName: "nestedQuestionnaire",
  entities: [],
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "translations",
  },
  sorting: {
    property: "position",
    sortable: true,
  },
  reorder: true,
  fields: {
    list: [
      //columns to be used in the table/list display, Order IS important
      {
        fieldName: "position",
        displayName: "Order",
        sortProperty: true,
      },
      {
        fieldName: "active",
        displayName: "Active",
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "widgetType",
        widget: "selectRenderer",
        fieldSelector: {
          INPUT: "Free text",
          SELECT: "Drop down",
          STAY_DATE: "Stay Date Selector",
          CHECKBOX: "checkbox",
          PHONE: "phone",
        },
        displayName: "Type of Answer",
      },
      {
        fieldName: "required",
        displayName: "Required",
      },
    ],
    form: [
      //fields to be used in the creation/edit form display, Order IS important
      {
        fieldName: "position",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Active",
        widget: "singleSwitch",
        defaultValue: false,
        className: "activeCheckbox",
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        readOnly: true,
        widget: "input",
        className: "tickerInput",
      },
      {
        fieldName: "required",
        displayName: "Required",
        defaultValue: false,
        widget: "checkbox",
      },
      {
        fieldName: "widgetType",
        displayName: "Type of answer",
        widget: "selector",
        optionDisplay: {
          INPUT: {
            label: "Free text",
          },
          SELECT: {
            label: "Drop down",
          },
          // CHECKBOX: {
          //   label: "Checkbox"
          // },
          STAY_DATE: {
            label: "Stay Date Selector",
          },
          PHONE: {
            label: "phone",
          },
        },
        defaultValue: "INPUT",
      },
      {
        fieldName: "label",
        widget: "input",
        displayName: "Question",
        className: "tickerInput",
        translated: true,
      },
      {
        fieldName: "placeholder",
        widget: "input",
        displayName: "placeholder",
        className: "tickerInput",
        translated: true,
      },
      {
        fieldName: "items",
        displayName: "Answer Options",
        widget: "input",
        placeholder: "option1,option2,option3...",
        translated: true,
        visible: ({ formValues }) =>
          formValues.widgetType === "SELECT" || formValues.widgetType === "CHECKBOX",
      },
    ],
  },
  validation: {
    ticker: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    label: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
